/**
 * Mega Menu panels
 *
 * @version 	2025.12.03
 * @name   		CSlice\JS\Mega_Menu
 */

// Main MEGA MENU
document.addEventListener('DOMContentLoaded', () => {
	// MEGA menu
	const megaMenu = document.querySelector('.MegaMenu');
	if (megaMenu) {
		// Settings
		const toggleActiveClass = 'is-active';
		const bodyOpenClass = 'is-menu-open';
		const bodyPanelClass = 'has-panel-open';
		const panelOpenClass = 'is-panel-open';

		// Mobile menu toggle
		const menuToggle = document.getElementById('menuToggle');
		if (menuToggle) {
			menuToggle.addEventListener('click', () => {
				if (menuToggle.classList.contains(toggleActiveClass)) {
					document.body.classList.remove(bodyOpenClass);
					menuToggle.classList.remove(toggleActiveClass);
				} else {
					document.body.classList.add(bodyOpenClass);
					menuToggle.classList.add(toggleActiveClass);
				}
			});
		}

		// Mega menu panels
		let openTimeout, closeTimeout;
		const menuItems = megaMenu.getElementsByClassName('MegaMenuItem');

		const closeOtherMenuItems = (menuItem) => {
			Array.from(menuItems).forEach((otherMenuItem) => {
				if (
					otherMenuItem !== menuItem &&
					otherMenuItem.classList.contains(panelOpenClass)
				) {
					otherMenuItem.classList.remove(panelOpenClass);
					otherMenuItem
						.querySelector('.MegaMenuItem-trigger')
						.setAttribute('aria-expanded', 'false');
				}
			});
		};

		const handleMenuTriggerClick = (event) => {
			const menuItem = event.currentTarget.closest('.MegaMenuItem');
			console.log('menuItem', menuItem);
			if (window.innerWidth < 1200) {
				closeOtherMenuItems(menuItem);

				// Toggle this item panel
				menuItem.classList.toggle(panelOpenClass);
				const isOpen = menuItem.classList.contains(panelOpenClass);
				menuItem
					.querySelector('.MegaMenuItem-trigger')
					.setAttribute('aria-expanded', isOpen);
			}
		};

		const handleMouseOver = (event) => {
			const menuItem = event.currentTarget.closest('.MegaMenuItem');
			if (window.innerWidth >= 1200) {
				clearTimeout(openTimeout);
				clearTimeout(closeTimeout);
				openTimeout = setTimeout(() => {
					closeOtherMenuItems(menuItem);

					// Open this item panel
					document.body.classList.add(bodyPanelClass);
					menuItem.classList.add(panelOpenClass);
					menuItem
						.querySelector('.MegaMenuItem-trigger')
						.setAttribute('aria-expanded', 'true');
				}, 100); // 300 is too slow
			}
		};

		const handleMouseLeave = (event) => {
			const menuItem = event.currentTarget.closest('.MegaMenuItem');
			if (window.innerWidth >= 1200) {
				clearTimeout(openTimeout);
				closeTimeout = setTimeout(() => {
					// Close this item panel
					menuItem.classList.remove(panelOpenClass);
					menuItem
						.querySelector('.MegaMenuItem-trigger')
						.setAttribute('aria-expanded', 'false');

					// Only remove body class if NO panels are open
					const anyPanelOpen = megaMenu.querySelector('.MegaMenuItem.' + panelOpenClass);
					if (!anyPanelOpen) {
						document.body.classList.remove(bodyPanelClass);
					}
				}, 400);
			}
		};

		const handleKeyDown = (event) => {
			// Make sure the keydown doesn't cascade down to inputs inside the menu
			if (
				!event.target.classList.contains('MegaMenuItem-trigger') &&
				!event.target.classList.contains('MegaMenuItem')
			) {
				return;
			}
			const menuItem = event.currentTarget.closest('.MegaMenuItem');
			if (event.key === 'Enter' || event.key === ' ') {
				const isOpen = menuItem.classList.toggle(panelOpenClass);
				menuItem
					.querySelector('.MegaMenuItem-trigger')
					.setAttribute('aria-expanded', isOpen);

				// Update body class for keyboard navigation
				if (isOpen) {
					document.body.classList.add(bodyPanelClass);
				} else {
					const anyPanelOpen = megaMenu.querySelector('.MegaMenuItem.' + panelOpenClass);
					if (!anyPanelOpen) {
						document.body.classList.remove(bodyPanelClass);
					}
				}

				handleNoScroll();
			}
		};

		Array.from(menuItems).forEach((menuItem) => {
			menuItem.setAttribute('tabindex', '0'); // Accessibility: Add tabindex to .MegaMenuItem
			const menuTrigger = menuItem.querySelector('.MegaMenuItem-trigger');
			if (menuTrigger) {
				menuTrigger.setAttribute('aria-expanded', 'false');
				menuTrigger.addEventListener('click', handleMenuTriggerClick);
				menuTrigger.addEventListener('mouseover', handleMouseOver);
				menuTrigger.addEventListener('keydown', handleKeyDown);
				menuItem.addEventListener('mouseleave', handleMouseLeave);
				menuItem.addEventListener('mouseenter', () => clearTimeout(closeTimeout));
			}
			menuItem.addEventListener('keydown', handleKeyDown); // Add keydown event listener to .MegaMenuItem
		});
	}
});
